import { SyncSwapClassicPool__factory } from '@contracts';
import { VenoSDKModule } from './base';
import { ETH_DECIMALS, expandDecimals, ONE_USD, USDT_DECIMALS, } from './constants';
export default class SyncSwapEthUsdtClassicPoolModule extends VenoSDKModule {
    constructor() {
        super(...arguments);
        this.contractFactory = SyncSwapClassicPool__factory;
        this.contractAddress = this.sdk.addresses.syncSwapWethUsdClassicPool;
    }
    async getEthPrice() {
        const [ethAmount, usdtAmount] = await this.getContract().getReserves();
        // 1USD * ((usdtAmount / USDT_DECIMALS) / (ethAmount / ETH_DECIMALS))
        return ONE_USD.mul(usdtAmount)
            .mul(expandDecimals(ETH_DECIMALS - USDT_DECIMALS))
            .div(ethAmount);
    }
}
